export default "__VITE_ASSET__CDUhwpY2__"